import { render, staticRenderFns } from "./relation-query.vue?vue&type=template&id=c7caf7da"
import script from "./relation-query.vue?vue&type=script&lang=ts"
export * from "./relation-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports